import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';
import { TaskItem } from './TaskItem';
import { TaskListProps } from './types';

const TaskList: React.FC<TaskListProps> = ({
  title,
  subtitle,
  tasks = [],
  showMore = false,
  onShowMore = () => {},
  onTaskClick = () => {},
  onActionClick = () => {},
  className = '',
}) => {
  return (
    <div className={cn('bg-white p-6 rounded-lg shadow-sm', className)}>
      <div className="flex justify-between items-center mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
        </div>
      </div>

      {tasks.length > 0 ? (
        <div className="space-y-3">
          {tasks.map(task => (
            <TaskItem
              key={task.id}
              task={task}
              onTaskClick={onTaskClick}
              onActionClick={onActionClick}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <p>No tasks to display.</p>
        </div>
      )}

      {showMore && tasks.length > 0 && (
        <div className="mt-6 text-center">
          <Button variant="outline" onClick={onShowMore}>
            Show more
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

TaskList.displayName = 'TaskList';

export { TaskList };
